import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

const SearchInput = ({
  className,
  isDisabled,
  onChange,
  value,
  placeholder,
  onClear,
}) => {
  return (
    <div
      className={`relative focus:outline-none focus:shadow-none focus:border-transparent ${className}`}
      data-testid="search"
    >
      <span className="absolute inset-y-0 left-0 flex items-center pl-2">
        <SearchIcon className="fill-current w-4 h-4 text-gray-400" />
      </span>
      <input
        value={value}
        className="h-full text-sm placeholder-gray-400 bg-white rounded pl-10 focus:outline-none focus:shadow-none border border-javelin-gray-border w-full input"
        placeholder={placeholder}
        autoComplete="off"
        onChange={onChange}
        disabled={isDisabled}
      />
      {onClear && !!value && (
        <span
          className="absolute inset-y-0 right-0 flex items-center pr-4"
          onClick={onClear}
        >
          <FontAwesomeIcon
            icon="times"
            size="sm"
            className="w-4 h-4 fill-current text-gray-400"
          />
        </span>
      )}
    </div>
  );
};

SearchInput.propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onClear: PropTypes.func,
};
SearchInput.defaultProps = {
  className: 'w-80 text-gray-400 focus-within:text-gray-400 h-10 lg:mr-4',
  isDisabled: false,
  placeholder: 'Search orders',
  onChange: () => {},
};

export default memo(SearchInput);
